<template>
  <div class="profile">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container mt--6 minHeight">
      <div class="row">
        <div class="col-xl-12 order-xl-1">
          <card no-body body-classes="px-0 pb-1" footer-classes="pb-2" class="createAdminContainer">
            <div slot="header" class="row align-items-center">
              <div class="col-lg-10 col-8">
                <h3 class="mb-0">
                  {{ action === 'create' ? 'Create Category' : 'Update Category' }}
                </h3>
              </div>
              <b-row v-if="loading" class="col-lg-12 col-12 no-gutters">
                <div class="col-lg-12 text-center">
                  <pulse-loader :color="'#3867d6'"></pulse-loader>
                </div>
              </b-row>
            </div>

            <b-row id="categoryFormContainer">
              <div class="col-lg-12 col-md-12 col-12">
                <b-card no-body>
                  <b-card-body class="pt-0">
                    <b-row>
                      <form class="w-100">
                        <div class="p-lg-4 px-lg-4 px-md-4 px-sm-4">
                          <div class="row px-4">
                            <div class="col-lg-6">
                              <b-form-group role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="category">Category </label>
                                <input
                                  v-model.trim="category"
                                  v-validate="'required'"
                                  type="text"
                                  name="category"
                                  data-vv-as="category"
                                  data-vv-name="category"
                                  placeholder="Enter Category"
                                  class="form-control no-instruction"
                                  :class="{
                                    input: true,
                                    'is-invalid': errors.has('category'),
                                    'has-invalid': errors.has('category'),
                                  }" />
                                <span class="has-icon-feedback"></span>
                                <div class="invalid-feedback" :is-invalid="errors.has('category')">
                                  {{ errors.first('category') }}
                                </div>
                              </b-form-group>

                              <b-form-group role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="description">Description </label>
                                <input
                                  v-model.trim="description"
                                  v-validate="'required'"
                                  type="text"
                                  name="description"
                                  data-vv-as="description"
                                  data-vv-name="description"
                                  placeholder="Enter Description"
                                  class="form-control no-instruction"
                                  :class="{
                                    input: true,
                                    'is-invalid': errors.has('description'),
                                    'has-invalid': errors.has('description'),
                                  }" />
                                <span class="has-icon-feedback"></span>
                                <div class="invalid-feedback" :is-invalid="errors.has('description')">
                                  {{ errors.first('description') }}
                                </div>
                              </b-form-group>
                            </div>
                            <div class="col-lg-6">
                              <b-form-group v-if="false" role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="image">Category Image </label>
                                <b-form-file
                                  id="image"
                                  ref="coverPhotofileInput"
                                  v-model="image"
                                  accept="image/png, image/jpeg"
                                  placeholder="Choose or Drag photo here..."
                                  drop-placeholder="Drop file here..."
                                  :class="{ hidden: imageUrl }"
                                  class="uploadPhotos"
                                  @change="coverPhotoFileChange"></b-form-file>
                                <div v-if="imageUrl" class="imageContainer">
                                  <a class="upload-image-link" onclick="document.getElementById('image').click()">
                                    <div class="upload-image-overlay">Choose photo here...</div>
                                    <img v-if="imageUrl" :src="imageUrl" alt="" class="mw-100 mx-auto image-preview" />
                                  </a>
                                </div>
                              </b-form-group>
                            </div>
                          </div>

                          <div class="row mt-5 px-4">
                            <div class="col-lg-5 col-md-5 col-12">
                              <router-link ref="clear" :to="`/content-provider/categories/`" exact class="btn btn-outline-vobo pr-5 pl-5 w-sm-100"
                                >Cancel</router-link
                              >
                            </div>
                            <div class="col-lg-7 col-md-7 col-12">
                              <button
                                v-if="action === 'create'"
                                v-promise-btn="{ minTimeout: 1500 }"
                                type="button"
                                :disabled="loading"
                                class="btn btn-vobo float-right w-sm-100 mb-3 mb-md-0"
                                @click="createCategory">
                                Create Category
                              </button>
                              <button
                                v-else-if="action === 'edit'"
                                v-promise-btn="{ minTimeout: 1500 }"
                                type="button"
                                :disabled="loading"
                                class="btn btn-vobo float-right w-sm-100 mb-3 mb-md-0"
                                @click="updateCategory">
                                Save Changes
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </b-row>
                  </b-card-body>
                </b-card>
              </div>
            </b-row>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import * as Cookies from 'js-cookie';
import { Validator } from 'vee-validate';
import { NotificationTypes, wrapNotification } from '@/utils/notification';

Vue.use(Cookies);

export default {
  data() {
    return {
      categoryID: null,
      categoryItem: {},
      category: '',
      description: '',
      image: '',
      imageUrl: '',
      imageFilename: '',
      action: '',
      hasError: false,
    };
  },
  computed: {
    loading: {
      get: function () {
        return this.$store.state.contentProvider.categoryLoading || false;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    selectedCompany: {
      get: function () {
        let selectedCompany = this.$store.state.company.selectedCompany || Cookies.get('companyID');
        return selectedCompany;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    companyName: {
      get: function () {
        let company = this.$store.state.company.company || null;
        if (company) {
          return company.name;
        }
        return null;
      },
      set: function (newValue) {
        return newValue;
      },
    },
  },
  mounted() {
    const categoryFormContainer = document.getElementById('categoryFormContainer');
    categoryFormContainer.classList.add('non-clickable');

    let companyID = Cookies.get('companyID') || '';

    if (!companyID || companyID === '') {
      this.$swal
        .fire({
          type: 'warning',
          position: 'center',
          imageWidth: 150,
          title: 'Organization is Required',
          html: 'Please select organization from the dropdown first located in upper left of the screen in order to create content provider category',
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: 'Go back to content provider category',
          confirmButtonClass: 'btn btn-primary pr-5 pl-5',
          footer: '<div class="text-center"> </div>',
          buttonsStyling: false,
          allowOutsideClick: false,
        })
        .then((result) => {
          if (result.value) {
            this.$router.push('/content-provider/categories/');
          }
        });
      categoryFormContainer.classList.add('non-clickable');
    } else {
      this.companyID = companyID;
      categoryFormContainer.classList.remove('non-clickable');

      this.action = this.$route.params.action;
      this.categoryID = this.$route.params.id;
      if (this.categoryID) {
        this.loadCategoryItem(this.categoryID);
      }
    }
  },
  methods: {
    createCategory() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          const formData = new FormData();

          this.categoryItem = {
            category: this.category,
            description: this.description,
            companyID: this.selectedCompany,
          };

          const { category, description, companyID } = this.categoryItem;

          formData.append('category', JSON.stringify({ category, description, companyID }));
          formData.append('image', this.image);

          this.$store
            .dispatch('contentProvider/CREATE_CP_CATEGORY', formData)
            .then((res) => {
              if (res.data.success) {
                wrapNotification(this.$notify, NotificationTypes.Success, 'Category successfully created');
                this.categoryID = null;
                this.categoryItem = {};
                this.category = '';
                this.description = '';
                this.image = '';
                this.imageUrl = '';
                this.imageFilename = '';
                this.action = '';

                this.$router.push('/content-provider/categories');
              } else {
                wrapNotification(this.$notify, NotificationTypes.Error, 'Error creating category');
              }
            })
            .catch((err) => {
              console.error(err);
              err.then((error) => {
                wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords(error.errMessage));
                this.hasError = true;
              });
            });
        }
      });
    },
    loadCategoryItem(categoryID) {
      this.$store.dispatch('contentProvider/GET_CP_CATEGORY_BY_ID', categoryID).then((res) => {
        this.category = res.category;
        this.description = res.description;
        this.imageUrl = res.image;
        this.imageFilename = res.imageFilename;
      });
    },
    updateCategory() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          const formData = new FormData();

          this.categoryItem = {
            category: this.category,
            description: this.description,
            imageFilename: this.imageFilename,
          };

          const { category, description, imageFilename } = this.categoryItem;
          const categoryID = this.categoryID;

          formData.append('category', JSON.stringify({ category, description, imageFilename }));
          formData.append('image', this.image);

          this.loading = true;
          this.$store
            .dispatch('contentProvider/UPDATE_CP_CATEGORY', {
              formData,
              categoryID,
            })
            .then((res) => {
              if (res.data.success) {
                this.loading = false;
                this.categoryItem = {};
                this.category = '';
                this.description = '';
                this.image = '';
                this.imageUrl = '';
                this.$router.push('/content-provider/categories');
                wrapNotification(this.$notify, NotificationTypes.Success, 'Category successfully updated');
              } else {
                wrapNotification(this.$notify, NotificationTypes.Error, 'Error updating category');
              }
            })
            .catch((err) => {
              console.error(err);
              err.then((error) => {
                wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords(error.errMessage));
                this.hasError = true;
              });
            });
        }
      });
    },
    coverPhotoFileChange(e) {
      let file = e.target.files[0];
      if (!file) {
        file = e.dataTransfer.files[0];
      }
      var reader = new FileReader();
      var self = this;
      reader.addEventListener('load', function (event) {
        var image = event.target;
        self.imageUrl = image.result;
      });

      reader.readAsDataURL(file);
    },
  },
};
</script>
<style lang="scss">
.createAdminContainer select {
  color: #525f7f !important;
}
.imageContainer {
  height: 300px;
  position: relative;
}
.image-preview {
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 0.375rem;
}
.upload-image-link {
  width: 100%;
  height: 100%;
}
.upload-image-link:hover .upload-image-overlay {
  display: block;
}
.upload-image-overlay {
  width: 100%;
  height: 100%;
  border-radius: 0.375rem;
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  text-align: center;
  color: #e5e5e5;
  line-height: 300px;
  display: none;
}
.hidden {
  display: none;
}
.uploadPhotos {
  font-size: 14px;
}
</style>
